import React, { useEffect, useState } from 'react';
import { get, post } from '../common/httpService';
import marketingAndAnalyticsService from '../services/marketingAndAnalytics/marketingAndAnalyticsService';
import Button from './Button.jsx';

import './PopUp.scss';
import { logError } from '../tracing.js';

const PopUp = () => {
  const [popUpInfo, setPopUpInfo] = useState({
    show: false,
    cancelUrl: '',
    buttonText: '',
    buttonLink: '',
    backgroundColor: '',
    textColor: '',
    borderColor: '',
    heading: '',
    text: '',
    validFrom: '',
    validTo: '',
  });

  const handleClose = async () => {
    try {
      await post({
        url: `home/PopUp`,
      });
      await marketingAndAnalyticsService.closePopUp();

      setPopUpInfo((prevState) => ({
        ...prevState,
        show: false,
      }));
    } catch (error) {
      logError(error);
    }
  };

  const getPopUpInfo = async () => {
    try {
      const r = await get({
        url: `home/ShowPopUp`,
      });
      setPopUpInfo(r);
    } catch (error) {
      logError(error);
    }
  };

  const handleButtonClick = async () => {
    try {
      await marketingAndAnalyticsService.popUpButtonClick();
      window.location = popUpInfo.buttonLink;
    } catch (error) {
      logError(error);
    }
  };

  useEffect(() => {
    getPopUpInfo();
  }, []);

  const style = {
    backgroundColor: popUpInfo.backgroundColor,
    color: popUpInfo.textColor,
    borderColor: popUpInfo.borderColor,
  };

  return popUpInfo.show ? (
    <div className='newsletter-popup' style={style}>
      <div className='newsletter-icon-container'>
        <span className='newsletter-icon close' onClick={handleClose}>
          &times;
        </span>
      </div>
      <div className='newsletter-text-container'>
        <h3>{popUpInfo.heading}</h3>
        <p dangerouslySetInnerHTML={{ __html: popUpInfo.text }} />
      </div>
      <Button
        className='button button--primary'
        text={popUpInfo.buttonText}
        onClick={handleButtonClick}
      />
    </div>
  ) : (
    <></>
  );
};

export default PopUp;
